import React from "react";
const SearchBar = ({ searchField, search, searchableColumns, onFieldChange, onSearchChange }) => {
  return (
    <div className="search-bar-container">
      <div className="searchsr-bar">
        <select
          className="select-dropdown"
          onChange={(e) => onFieldChange(e.target.value)}
          value={searchField || ""}
        >
          {searchableColumns.map((column) => (
            <option key={column.key} value={column.key}>
              {column.label}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder={`Search by ${searchableColumns.find((col) => col.key === searchField)?.label || "Student Name"
            }...`}
          value={search || ""}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default React.memo(SearchBar);